/**
 * Created by dwiargo on 2/22/18.
 */

import LoaderInfo from './LoaderInfo';

export default LoaderInfo;